import { TermsDetails } from '@api/api.types'
import {
  UserTermsProps,
  useWalletTermsQueryOptions,
} from '@src/queryOptions/terms'
import { useSuspenseQuery } from '@tanstack/react-query'

export const useSuspenseWalletTerms = <TData = TermsDetails[]>(
  select?: UserTermsProps<TData>['select']
) => {
  const walletTermsQueryOptions = useWalletTermsQueryOptions(select)
  return useSuspenseQuery(walletTermsQueryOptions)
}
